module.exports = __webpack_public_path__ + "img/p1-c1-p2.8361379d.jpg";